import React from 'react';
import Typography from 'housecall-ui/dist/DesignSystem/DataDisplay/Typography/Typography';
import ScheduleEngineAppIcon from 'housecall-ui/dist/IconsAndImages/AppIcons/ScheduleEngineAppIcon';
import Grid from 'housecall-ui/dist/DesignSystem/Layout/Grid/Grid';
import ScheduleEngineButton from '../OtherComponents/ScheduleEngineButton';

const imageStyles = {
  display: 'block',
  maxWidth: '100%',
  height: 'auto',
};

const ScheduleEngineStrategy = {
  headerInfo: {
    name: 'Schedule Engine',
    category: 'Online booking',
    details: (
      <div>
        <p><strong>Turn your website into a booking machine.</strong></p>
        <p><strong>Capture more business with self-service online booking and 24/7 live expert support</strong></p>

        <p>
          In today’s on-demand world customers don’t wait. If you aren’t booking appointments around the clock,
          you’re losing out on business. Schedule Engine’s customizable online booking, live chat and voice services
          make it easy for home service contractors to deliver a convenient, reliable customer experience and book
          more qualified jobs – anytime, night or day.
        </p>
      </div>
    ),
    iconSvg: <ScheduleEngineAppIcon size="jumbo" />,
  },
  media: {
    wistiaLink: 'https://player.vimeo.com/video/454870331?title=0&byline=0&portrait=0',
  },
  price: {
    price: '',
    hideToggle: true,
    appActionButton: <ScheduleEngineButton />,
    description: (
      <>
        <Typography paragraph>
          Because Schedule Engine is Housecall Pro’s preferred home services booking solution provider,
          Schedule Engine will waive your implementation fee (up to a $2,000 value) upon signup.
        </Typography>

        <Typography paragraph>
          For a limited time, early adopters will also get their first month with Schedule Engine <strong>free</strong>.
        </Typography>
      </>
    ),
  },
  supportContacts: [
    {
      type: 'Email',
      contact: <a href="mailto:hello@scheduleengine.com">hello@scheduleengine.com</a>,
    },
    {
      type: 'Phone',
      contact: <a href="tel:7173688825">717-368-8825</a>,
    },
  ],
  sellingPoints: {
    headline: '',
    bottomDescription: (
      <div>
        <Grid container spacing={10}>
          <Grid item xs={12}>
            <h4>Always-on Customer Booking</h4>
            <Typography paragraph>
              Schedule Engine is the only multi-channel booking solution built to meet
              the unique demands of home service contractors. Convert more leads into
              jobs and streamline your operations through customizable online booking
              solutions that keep you in control and up to date.
              Customers self-diagnose their issue, upload photos or videos and
              request their desired arrival window, converting more of your web
              traffic to real appointments that work with your schedule – no more phone tag.
            </Typography>
          </Grid>
        </Grid>

        <Grid container spacing={10}>
          <Grid item xs={12}>
            <img
              src="https://static-assets.housecallpro.com/app_store/apps/schedule_engine/screenshot-1.png"
              style={imageStyles}
              alt=""
            />
          </Grid>
        </Grid>

        <Grid container spacing={10}>
          <Grid item xs={12}>
            <h4>Make your website work harder for you!</h4>
            <Typography paragraph>
              Schedule Engine’s 24/7 live chat and voice offerings ensure you
              never miss an opportunity to connect with customers, provide knowledgeable
              help and book more qualified jobs. With personalized scripting,
              scheduling integrations, and emergency on-call escalation workflows
              our industry-trained experts are able to provide the same experience
              as a top-performing internal CSR.
            </Typography>
          </Grid>
        </Grid>

        <Grid container spacing={10}>
          <Grid item xs={12}>
            <img
              src="https://static-assets.housecallpro.com/app_store/apps/schedule_engine/screenshot-2.png"
              style={imageStyles}
              alt=""
            />
          </Grid>
        </Grid>

        <Grid container spacing={10}>
          <Grid item xs={12}>
            <h4>More Booked Jobs. Fewer Headaches.</h4>

            <Typography paragraph>
              Schedule Engine’s online booking solutions and live expert services
              work seamlessly with Housecall Pro to ensure dispatchers and technicians
              can complete their jobs efficiently – no more callbacks, double bookings,
              or mismatched technicians. Stay in control and up to date with automated
              messaging notifications and real-time access into inbound activity.
              Schedule Engine can be quickly implemented without any internal training
              or process changes.
            </Typography>
          </Grid>
        </Grid>
      </div>
    ),
  },
};

export default ScheduleEngineStrategy;
